import { render, staticRenderFns } from "./VideoAttachment.vue?vue&type=template&id=26b8dcc2&scoped=true&"
import script from "./VideoAttachment.vue?vue&type=script&lang=js&"
export * from "./VideoAttachment.vue?vue&type=script&lang=js&"
import style0 from "./VideoAttachment.vue?vue&type=style&index=0&id=26b8dcc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b8dcc2",
  null
  
)

component.options.__file = "VideoAttachment.vue"
export default component.exports